// Blog (yeniliklər) yazıları üçün Firestore CRUD servisi.
// Sənədlər `blog_posts` kolleksiyasında saxlanılır. Hər yazıda 3 dildə
// (az/en/ru) başlıq, üst yazı, qısa təsvir və əsas mətn var.

import {
  collection, doc, getDocs, getDoc, addDoc, updateDoc, deleteDoc,
  query, orderBy, serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase/config";

const COL = "blog_posts";

function slugify(s) {
  return String(s || "")
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[əƏ]/g, "e").replace(/[üÜ]/g, "u").replace(/[öÖ]/g, "o")
    .replace(/[şŞ]/g, "s").replace(/[çÇ]/g, "c").replace(/[ğĞ]/g, "g")
    .replace(/[ıİ]/g, "i")
    .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")
    .slice(0, 60) || `post-${Date.now()}`;
}

/** Bütün blog yazılarını qaytarır (yeni → köhnə) */
export async function listBlogPosts({ onlyPublished = false } = {}) {
  try {
    const snap = await getDocs(query(collection(db, COL), orderBy("date", "desc")));
    let posts = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    if (onlyPublished) posts = posts.filter((p) => p.published !== false);
    return posts;
  } catch (_e) {
    return [];
  }
}

/** Slug-a görə yazını qaytarır (slug, id və ya başlığa baxır) */
export async function getBlogPostBySlug(slug) {
  if (!slug) return null;
  try {
    const snap = await getDocs(collection(db, COL));
    const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    return list.find((p) => p.slug === slug) || list.find((p) => p.id === slug) || null;
  } catch (_e) {
    return null;
  }
}

/** ID ilə tək yazı */
export async function getBlogPost(id) {
  try {
    const ref = doc(db, COL, id);
    const snap = await getDoc(ref);
    return snap.exists() ? { id: snap.id, ...snap.data() } : null;
  } catch (_e) {
    return null;
  }
}

/** Yeni yazı əlavə edir. `payload`-da: title{az,en,ru}, body{az,en,ru}, cover_url, date, ... */
export async function createBlogPost(payload) {
  const slug = (payload.slug && slugify(payload.slug)) || slugify(payload.title?.az || payload.title?.en || "post");
  const data = {
    slug,
    cover_url: payload.cover_url || "",
    date: payload.date || new Date().toISOString().slice(0, 10),
    read_min: Number(payload.read_min) || 4,
    eyebrow: payload.eyebrow || { az: "", en: "", ru: "" },
    title:   payload.title   || { az: "", en: "", ru: "" },
    excerpt: payload.excerpt || { az: "", en: "", ru: "" },
    body:    payload.body    || { az: "", en: "", ru: "" },
    published: payload.published !== false,
    created_at: serverTimestamp(),
    updated_at: serverTimestamp(),
  };
  const ref = await addDoc(collection(db, COL), data);
  return { id: ref.id, ...data };
}

export async function updateBlogPost(id, patch) {
  const data = { ...patch, updated_at: serverTimestamp() };
  // Slug-u yenidən normallaşdır (boşdursa başlıqdan)
  if (patch.slug) data.slug = slugify(patch.slug);
  else if (patch.title?.az && !patch.slug) {
    // Yalnız mövcud slug yoxdursa başlıqdan yarat — burada tam yenidən
    // yaratma etmirik.
  }
  await updateDoc(doc(db, COL, id), data);
  return data;
}

export async function deleteBlogPost(id) {
  await deleteDoc(doc(db, COL, id));
}
